'use strict';

module Patersons {

    export class ValuationStatement extends AbstractReport {
        nonLoaSecurities: AssetCategory[];
        nonLoaUnsettledDividends: UnsettledDividends;
        loaSecurities: AssetCategory[];
        managedAccounts: {
            [key: string]: {
                grandTotal: ValuationStatementAsset,
                items: AssetCategory[];
            }
        };
        loaUnsettledDividends: UnsettledDividends;
        grandTotal: ValuationStatementAsset;
        managedAccountsGrandTotal: ValuationStatementAsset;
    }

    export class AssetCategory {
        categoryName: string;
        items: ValuationStatementAsset[];
        subtotal: ValuationStatementAsset;
        expanded: boolean;
    }

    export class ValuationStatementAsset {
        categoryName: string;
        code: string;
        securityName: string;
        quantity: number;
        costPrice: number;
        exchangeCode: string;
        price: number;
        reducedCostBase: number;
        marketPrice: number;
        marketValue: number;
        profitOrLoss: number;
        pctAssets: number;
        estIncome: number;
        estAnnualIncome: number;
        estAnnualGrossIncome: number;
        estFrankingCredits: number;
        estGrossYield: number;
        totalCost: number;
    }

    export class UnsettledDividends {
        items: UnsettledDividend[];
        subtotal: UnsettledDividend;
    }

    export class UnsettledDividend {
        code: string;
        securityCode: string;
        securityName: string;
        unsettledIncome: number;
        exchangeCode:string
    }
    export class ValuationStatementComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/valuationStatement.component.html';
        controller: any = ValuationStatementController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }
    export interface ValuationStatementScope extends ng.IScope {
        
        userCompany: UserCompany;
        events: Patersons.ValuationStatementController;
        
    }
    const sortFunds = (a, b) => a.code && a.code.localeCompare(b.code, undefined, {numeric: true}); 
    
    const extractManagedFunds = ( items) => {
        const managedFunds = items.filter((element) => {
            return element.exchangeCode === "FND"
        }).sort(sortFunds)        
        
       const unlisted = items.filter((element) => {
            return element.exchangeCode === "UNL"
        }).sort(sortFunds)

        const everythingElse = items.filter((element) => {
            return ["FND", "UNL"].indexOf(element.exchangeCode) === -1;
        }).sort(sortFunds)

        return [...everythingElse, ...managedFunds, ...unlisted] as typeof items

    }

    export class ValuationStatementController extends AbstractReportController {
        report: ValuationStatement;
        morningStarService: Patersons.MorningStarService;
        userCompanyService: Patersons.UserCompanyService;
        scope: Patersons.ValuationStatementScope;
        $rootScope: any;
        static $inject = ['$scope', '$rootScope', 'morningStarService', 'userCompanyService']; 
        constructor($scope, $rootScope, morningStarService, userCompanyService){
            super();
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.scope.events = this;
            this.morningStarService = morningStarService
            this.userCompanyService = userCompanyService;

            this.userCompanyService.getUserCompany().then((company) => {
                this.scope.userCompany = company
                if(company.enableFeature){
                    this.load();
                }
            })
        }
        toggleManagedAccount = (key, managedAccountIndex) => {
            this.report.managedAccounts[key].items[managedAccountIndex].expanded = !this.report.managedAccounts[key].items[managedAccountIndex].expanded;
        }
        load(){ 
            let codes = [];
            this.report.nonLoaSecurities.forEach(category => {
                category.items.forEach(item => {
                    codes.push({
                        code: item.code,
                        exchangeCode: item.exchangeCode
                    })
                })
                category.items = extractManagedFunds(category.items)

            })
            Object.keys(this.report.managedAccounts).forEach(key => {
                    let  sortedItem =this.report.managedAccounts[key].items.sort((a,b) => a.categoryName.localeCompare(b.categoryName));
                      
                    var first = "CG Large Cap Australian Equity Portfolio";
                        sortedItem.forEach(function(item,i){
                          if(item.categoryName === first){
                            sortedItem.splice(i, 1);
                            sortedItem.unshift(item);
                          }
                        });
                                           
                this.report.managedAccounts[key].items = sortedItem;

                this.report.managedAccounts[key].items.forEach(category => {
                    category.items.forEach(item => {
                        codes.push({
                            code: item.code,
                            exchangeCode: item.exchangeCode
                        })
                    })
                    category.items = extractManagedFunds(category.items)
                })
            })
           
            this.report.loaSecurities.forEach(category => {
                category.items.forEach(item => {
                    codes.push({
                        code: item.code,
                        exchangeCode: item.exchangeCode
                    })
                })
                category.items = extractManagedFunds(category.items)
            })
            this.report.nonLoaUnsettledDividends.items.forEach(unsettledDividend => {
                codes.push({
                    code: unsettledDividend.code,
                    exchangeCode: unsettledDividend.exchangeCode
                })
                this.report.nonLoaUnsettledDividends.items = extractManagedFunds(this.report.nonLoaUnsettledDividends.items)
            })
            this.report.loaUnsettledDividends.items.forEach(unsettledDividend => {
                codes.push({
                    code: unsettledDividend.code,
                    exchangeCode: unsettledDividend.exchangeCode
                })
                this.report.loaUnsettledDividends.items = extractManagedFunds(this.report.loaUnsettledDividends.items)
            })
            codes = codes.filter((value, index, self) => self.indexOf(value) === index);

            codes.forEach(code => {
                this.morningStarService.getMorningStarDataForSecurityCode(code.exchangeCode, code.code).then(res => {
                    if(res){
                        const elem = $('td:first-child:not(:has(a))').filter(function () {
                            return $(this).text().trim() === code.code;
                        }).first();
                        var openURL = '';
                        var secId = res.FundShareClassId;
                        openURL = mapHoldingTypeIdToReportURL(res.holdingTypeId);

                        if(openURL){
                            openURL += '#/' + secId;
                            elem.html('<a target="_blank" href="' + openURL + '">' + code.code + '</a>');
                            elem.siblings('.has-data-link').each(function(){
                                const child = $(this);
                                child.html('<a target="_blank" href="' + openURL + '">' + child.text() + '</a>')
                            })
                        }
                    }
                })
            })
        }
    }
}
